import InvestorInvestManageBanner from './investor-invest-manage-banner';

export default InvestorInvestManageBanner;
